export default class WorkShift {
  id= 0
  description = ""
  end = ""
  start = ""
  reference = 0;
}